<template>
  <div class="toast-wrapper">
    <div :style="{ background }" class="toast">{{ props.message }}</div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
interface ToastProps {
  message: string
  type: string
}
const props = defineProps<ToastProps>()
const background = computed<string>(() => {
  if (props.type === 'success') {
    return '#00c853'
  } else if (props.type === 'error') {
    return '#ff5252'
  } else if (props.type === 'warning') {
    return '#ff9800'
  } else if (props.type === 'info') {
    return '#2196f3'
  }
  return '#ff9800'
})
</script>

<style scoped lang="scss">
@use '@/styles/variables';
.toast-wrapper {
  position: fixed;
  width: 100%;
  top: 20px;
  cursor: pointer;
  z-index: 1000;
}
.toast {
  padding: 20px;
  color: variables.$color-grey-light;
  border-radius: 10px;
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: fit-content;
  margin: 0 auto;
}
</style>
